
// src/connects/draft-selection-dialog.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'

export const mapStateToProps = (state) => {
  return {
    isFetching: state.savedDiaries.isFetching
  }
}

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    deleteSavedDiary: (diary_id)=> dispatch(actions.deleteSavedDiary(diary_id)),
    editSavedDiary: (diary_id)=> dispatch(actions.editDiary(diary_id)),
    deleteAllSavedDiary: (group_id) => dispatch(actions.deleteAllSavedDiary(group_id))
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
)
  



// WEBPACK FOOTER //
// ./src/connects/draft-selection-dialog.js